import {message} from "antd";
import {useGetProfileContext} from "../../context/profile/profile-context";
import {useGetCoachConnectCalendarStatusContext} from "../../context/connect-calendar/connect-calendar-status.context";
import {
  useCoachConnectCalendarGoogleSignIn,
  useCoachDisconnectCalendar,
} from "./connect-calendar";

export function useGoogleCalendarConnection() {
  const {state: profileState} = useGetProfileContext();
  const {state: connectCalendarStatus} = useGetCoachConnectCalendarStatusContext();
  const coachConnectCalendarGoogleSignInMutation = useCoachConnectCalendarGoogleSignIn();
  const coachDisconnectCalendarMutation = useCoachDisconnectCalendar();

  const email = profileState.profileData.email;
  const isConnected = !connectCalendarStatus.connectCalendarStatus.needs_login;

  function connect() {
    coachConnectCalendarGoogleSignInMutation.mutate(email, {
      onSuccess(data) {
        const redirectUrl = data.data.redirectUrl ?? data.data.url;
        if (redirectUrl) {
          window.location.assign(redirectUrl);
        }
      },
    });
  }

  function disconnect() {
    coachDisconnectCalendarMutation.mutate(email, {
      onSuccess() {
        message.success("Calendar disconnected successfully!");
      },
    });
  }

  return {
    email,
    isConnected,
    connect,
    disconnect,
    isConnecting: coachConnectCalendarGoogleSignInMutation.isLoading,
    isDisconnecting: coachDisconnectCalendarMutation.isLoading,
  };
}
